import { Stack, TextField } from '@mui/material';
import Typography from '../../../../../../../components/Typography/Typography';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface OrderPaymentWhatsappContentProps {
  message: string;
  onChangeMessage: (message: string) => void;
}

const OrderPaymentWhatsappContent = ({
  message,
  onChangeMessage,
}: OrderPaymentWhatsappContentProps) => {
  const { translate } = useTranslation();

  return (
    <Stack spacing={2}>
      <Typography color="text.secondary">
        {translate(LangEnum.PAYMENT_LINK_CUSTOMIZE_MESSAGE)}
      </Typography>
      <TextField
        label={translate(LangEnum.INVITE_AND_CONNECT_MODAL_MESSAGE)}
        value={message}
        onChange={(e) => onChangeMessage(e.target.value)}
        multiline
        variant="outlined"
        fullWidth
        rows={3}
      />
    </Stack>
  );
};

export default OrderPaymentWhatsappContent;
